import extend from 'lodash/extend';

module.exports = extend(
    // require('./partials/startFrame'),
    require('./partials/puppetMasters'),
    require('./partials/trioFunnel'),
    require('./partials/treadmill'),

    require('./partials/pipeFlow'),
    require('./partials/blob'),

    require('./partials/bucketFullFrame'),
    require('./partials/bucketAnalyser'),
    // require('./partials/title'),
    // require('./partials/endFrame'),
    //
    require('./partials/pipes'),

    require('./titles/regulation'),

    require('./general/tiles'),
    // require('./general/faces'),
    // {
    //     pipesTitle: {
    //         //texture: '/img/scenes/regulation/pipes.png',
    //         texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/pipes.png',
    //         scale: {
    //             x: '100%'
    //         }
    //     },
    //
    //     regulationTitle: {
    //         texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/regulation-title.png'
    //     },
    //
    //     regulationTitleFr: {
    //         texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/regulation-title-fr.png'
    //     }
    // }
);



// WEBPACK FOOTER //
// ./js/objects/regulation.js